import * as angular from 'angular';
import * as d3 from 'd3';

import { ComponentDefinition, TicketViewModel, TicketStatusId, TicketStatus } from '../../../../models';
import { ICategoricalChartOptions } from '../../../../wtFramework';
import { colorScale } from '../colorScale';
import { whiteTextColor } from '../../../../common';

class TicketsByStatusBarController implements angular.IComponentController {
    isLoading: boolean;
    tickets: TicketViewModel[];
    options: ICategoricalChartOptions;
    series: any[];
    data: any[];
    ticketStatuses: TicketStatus[];
    colorScale = colorScale;
    
    static $inject = ['$translate'];
    constructor(private _$translate: angular.translate.ITranslateService) {
    }

    $onInit() {
        this.options = {
            color: whiteTextColor,
            dataFormat: {
                identifier: d => d.status,
                label: d => this._$translate.instant(d.status),
                value: d => d.value
            },
            isLabelsVisible: false,
            isTitleVisible: false,
            isRectangleVisible: true,
            isVerticalLineVisible: true,
            xTickFormat: '0'
        };
        this.series = this.series || [];
        this.data = this.data || [];
    }

    $onChanges(changesObj: angular.IOnChangesObject) {
        if ((changesObj['tickets'] || changesObj['ticketStatuses']) && this.tickets && this.ticketStatuses) {
            const statusDic = {};
            this.ticketStatuses.forEach(status => {
                statusDic[status.id] = status.name;
            });
            const byStatus = d3.nest<TicketViewModel>()
                .key(d => statusDic[d.model.statusId])
                .entries(this.tickets.filter(t => t.model.statusId !== TicketStatusId.Closed))
                .map(d => {
                    return {
                        status: d.key,
                        value: d.values.length
                    };
                });
            const domain = this.colorScale.domain();
            this.series = domain
                .slice(0, domain.length - 1)// Remove last element - 'Closed'
                .map(d => {
                    return {
                        status: d,
                        color: this.colorScale(d)
                    };
                });
            this.data = byStatus;
        }
    }
}

export const wtTicketsByStatusBar: ComponentDefinition = {
    componentId: 'wtTicketsByStatusBar',
    controller: TicketsByStatusBarController,
    template: require('./ticketsByStatusBar.component.html'),
    controllerAs: 'vm',
    bindings: {
        isLoading: '<',
        tickets: '<',
        ticketStatuses: '<'
    }
};
